export const API_URL = process.env.REACT_APP_API_URL;
export const CLOUDFLARE_SITEKEY =
  process.env.REACT_APP_CLOUDFLARE_SITEKEY ?? "";
